import React from 'react';
import { Link } from 'react-router-dom';
import Seo, { SITE } from '../Seo/Seo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-regular-svg-icons';

import graceHeadshot from '../../assets/GraceHeadshot.jpeg';
import anthonyHeadshot from '../../assets/ApicellaHeadshot2.png';
import anneliseHeadshot from '../../assets/Annelise Wall Headshot (r-cu).jpg';
import './Faculty.css';

// Bio TEXT is the repo's existing APPROVED copy, verbatim (Surface-6 rule —
// the mockup's rewrites are NOT used; Anthony's bio is parked and stays his).
// Source: the prior Faculty page's facultyList. Bios are stored as paragraph
// arrays (the template-literal source indentation was formatting, not content;
// Annelise's real \n\n paragraph breaks are preserved as separate entries).
const FACULTY = [
	{
		name: 'Grace Wall',
		role: 'Co-Owner · Teaching Artist',
		photo: graceHeadshot,
		bio: [
			"Grace began her vocal training at the Los Angeles County High School for the Arts where she trained in opera with Yale graduate and opera professional Stephanie Vlahos. She continued her training at UCLA, receiving a BA in Musical Theatre. After graduating, Grace went on to train in Bel Canto with Tony Award-winner Victoria Clark. From the Hollywood Bowl to Lincoln Center, Paris and London, Grace has performed all over the globe. She’s an LA Weekly Award-winning actress, and has appeared in numerous theatrical productions on both coasts. Grace has also had the pleasure of taking part in the workshops of several new musicals in NYC (including Disney Theatricals' The Hunchback of Notre Dame). Television credits include 90210, NBC’s The Voice, and National Geographic’s Robbery in the Sky.",
		],
	},
	{
		name: 'Anthony Apicella',
		role: 'Co-Owner · Teaching Artist',
		photo: anthonyHeadshot,
		// PARKED — repo's approved text, untouched (Anthony owns any rewrite).
		bio: [
			"Since attending the American Musical and Dramatic Academy in NYC, Anthony has traveled the world as a performer, gathering a wealth of experience. He has performed solo with symphonies across the globe in ‘Disney In Concert’ and ‘The Music of the Rat Pack’. He has also appeared in numerous musical theatre productions in and around NYC. Anthony co-created and is a member of The Copa Boys; a trio of singers dedicated to celebrating Jazz, The American Songbook and the singers that shaped them. Anthony is still performing and touring with symphonies. In addition to teaching along side Grace, he works as a freelance web developer. He received his training at UCLA’s Coding Bootcamp. He built and manages Color Your Voice’s website and business operations.",
		],
	},
	{
		name: 'Annelise Wall',
		role: 'Teaching Artist',
		photo: anneliseHeadshot,
		bio: [
			'Annelise Wall recently graduated from Southern Methodist University with a Bachelor of Fine Arts in Theatre and a minor in Music. Her favorite roles include Terpsichore in The Odyssey: The Musical (Dallas Theatre Center), Cathy Hyatt in The Last Five Years (Hold The Applause / Jaaziah Vallano Productions), and Anne Frank in The Diary of Anne Frank (Albuquerque Little Theater).',
			'Additional credits include Elle Woods in Legally Blonde, Cinderella in Cinderella, Kathy Selden in Singin’ in the Rain, Princess Fiona in Shrek, Dorothy in The Wizard of Oz, Karen Wright in The Children’s Hour (McCall Family Theater), Evil Gabbi in She Kills Monsters (The Vortex), and Rachel Shapiro in DeliKateSSen (VSA North Fourth Arts Center).',
			'Annelise is also the voice of the video game Kneedle Night. A versatile and accomplished singer, she has trained for over 13 years and specializes in musical theatre and R&B. She has taught theatre and voice for more than a decade, and is thrilled to be joining Color Your Voice as part of the teaching team.',
		],
	},
];

const Faculty = () => {
	return (
		<main className='cyv faculty-page'>
			<Seo
				title='Our Teachers | Color Your Voice'
				description='Meet the Color Your Voice teaching artists — Grace Wall, Anthony Apicella, and Annelise Wall — working artists who teach because they love it.'
				canonical={`${SITE}/faculty`}
			/>

			{/* ---- Hero (centered) ---- */}
			<header className='pg-hero'>
				<span className='eyebrow'>Our studio</span>
				<h1 className='brand-heading'>Our teachers</h1>
				<p>
					Working artists who teach because they love it — and who meet every
					student exactly where they are.
				</p>
			</header>

			{/* ---- Bio rows (Grace, Anthony, Annelise — alternating photo side) ---- */}
			<div className='fac'>
				{FACULTY.map((m, i) => (
					<article
						key={m.name}
						className={`fac-row${i % 2 === 1 ? ' fac-row--right' : ''}`}>
						<span className='fac-row__bar' />
						<div className='fac-row__photo'>
							<img src={m.photo} alt={`Headshot of ${m.name}`} />
						</div>
						<div className='fac-row__body'>
							<h2 className='fac-row__name'>{m.name}</h2>
							<span className='fac-row__role'>
								<FontAwesomeIcon icon={faStar} /> {m.role}
							</span>
							{m.bio.map((para, p) => (
								<p className='fac-row__bio' key={p}>
									{para}
								</p>
							))}
						</div>
					</article>
				))}
			</div>

			{/* ---- Closing CTA (centered) ---- */}
			<section className='fac-cta'>
				<div className='fac-cta__in'>
					<span className='accent-bar' />
					{/* Repointed from summer to fall 2026-08-08 — this CTA was one of the
					    last inbound links to /summer left on the marketing site. */}
					<h2 className='brand-heading'>Come sing with us this year</h2>
					<p>
						Weekly one-on-one voice lessons for kids and teens of every level —
						now enrolling for the 2026–27 school year.
					</p>
					<div className='fac-cta__btns'>
						<Link className='btn-cyv-teal' to='/register'>
							Enroll for fall →
						</Link>
						<Link className='btn-cyv-ghost' to='/contact'>
							Get started
						</Link>
					</div>
				</div>
			</section>
		</main>
	);
};

export default Faculty;
